module.exports = __webpack_public_path__ + "fa3996818d13a9c2ce2a8f78a8b5a773.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/svgQuarterMap/data/zhQuarterMap.svg
// module id = 252
// module chunks = 0